import React, {useState} from 'react';
import { Button, Row } from 'react-bootstrap';

import { useWeb3 } from './Web3Context';

const Sidebar: React.FC = () => {
  const { connector, hooks } = useWeb3();

  const {useSelectedAccount, useSelectedChainId, useSelectedIsActive, useSelectedIsActivating } = hooks
  const isActivating = useSelectedIsActivating(connector)
  const isActive = useSelectedIsActive(connector)
  const account = useSelectedAccount(connector)
  const chain = useSelectedChainId(connector)

  const [error, setError] = useState<Error | undefined>(undefined)
  const [connectionStatus, setConnectionStatus] = useState('Disconnected')

  const handleConnect = async () => {
    setError(undefined) // clear error state

    if (isActive) {
      if(connector?.deactivate) {
        void connector.deactivate()
      } else {
        void connector.resetState()
      }
    }
    else if (!isActivating) {
      setConnectionStatus('Connecting..')
        Promise.resolve(connector.activate(1))
        .then(() => {
          setConnectionStatus('Connected')
        })
        .catch((e) => {
          connector.resetState()
          setError(e)
        }) 
      }
  };

  return (
    <div style={{ width: '20vw', maxWidth: "300px", minWidth: "100px", backgroundColor: '#f8f9fa' }}>
      <Row className="flex-column p-3">
        {isActive && 
        <>
          <p>Status - {(error?.message) ? ("Error: " + error.message) : connectionStatus}</p>
          <p>Address - {account ? account : "No Account Detected"}</p>
          <p>ChainId -  {chain ? chain : 'No Chain Connected'}</p>
        </>
        }
        {!isActive && 
          // <Button variant="outline-dark" href="#login">Connect</Button>
          <Button onClick={handleConnect} variant="outline-dark" href="#login">Connect</Button>
        }
      </Row>
    </div>
  );
};

export default Sidebar;